<template>
  <td :style="tdStyle" :title="tdTitle">
    <span v-if="showWater" class="water-mark">{{ account }}</span>
    <span class="td-content">
      <span v-if="head.type == 'link' && hasSimi" class="simi-icon" size="mini" @click="onClickSimi">
        <i :class="simiClass"></i>
      </span>
      <span v-if="head.label == '通讯录'">
        <el-tooltip
          v-if="content"
          class="item"
          effect="dark"
          placement="top"
          :content="head.tooltip"
        >
          <span @click="onClick" class="a-link popper-btn">通讯录</span>
        </el-tooltip>
      </span>
      <span v-else-if="head.type == 'link'" :id="head.label + item._id" class="a-link popper-btn" @click="onClick">
        <i v-if="head.icon" :class="head.icon"></i>
        <span
          :id="head.label + item._id"
          class="a-link popper-btn"
          v-html="displayContent || content"
        />
        <span v-if="hasCcIcon" class="cc-icon cc-icon-g">c</span>
        <span v-if="hasO" class="cc-icon cc-icon-y" title="已offer">o</span>
        <span v-if="hasP" class="cc-icon cc-icon-r" title="已到岗">p</span>
        <span v-if="isXueku" class="el-icon-view" style="color:#F56C6C;margin-left:3px"></span>
      </span>
      <span v-else-if="head.type == 'tag'" @click="onClick">
        <span
          v-for="(c, k) in displayContent"
          :key="k + 't'"
          class="a-tag"
          :class="{'chushai-tag': c == '初筛通过'}"
          :style="{ cursor: head.onClick ? 'pointer' : '' }"
          v-html="c"
        >
        </span>
      </span>
      <span v-else-if="head.type == 'select'">
        <div class="a-td-cover">{{ value }}</div>
        <select v-model="value" class="a-td-select" @change="onChange">
          <template v-if="Array.isArray(head.options)">
            <option v-for="opt in head.options" :key="opt" :value="opt"> {{ opt || '--' }} </option>
          </template>
          <template v-else>
            <option v-for="(v, k) in head.options" :key="k" :value="k"> {{ v || '--' }} </option>
          </template>
        </select>
      </span>
      <span
        v-else-if="head.type == 'attach'"
        class="popper-btn"
        :class="{ 'a-link': content && content > 0 }"
        @click="onClick"
      >
        <i :id="head.label + item._id" class="el-icon-document"></i> {{ content || 0 }}
      </span>
      <span v-else-if="head.type == 'tooltip'" @mouseover="onMouseover">
        <el-tooltip
          v-if="content"
          class="item"
          effect="light"
          placement="top"
        >
          <pre slot="content" style="max-width:500px;white-space:pre-wrap;margin:0" v-html="head.handleContent ? head.handleContent(content) : content || displayContent"></pre>
          <span v-html="head.label === '手机' ? '***********' : displayContent || content"></span>
        </el-tooltip>
      </span>
      <span v-else v-html="displayContent || content"></span>
    </span>
  </td>
</template>
<script>
const dateFormat = require('dateformat')

export default {
  props: {
    head: {
      // {label:'姓名',field:'name',width:'100px',type:'text/link/tag/select/attach/star',content:'操作',icon:'el-icon-setting',options:[],onClick:Function,onChange:Function}
      type: Object,
      default: {},
    },
    item: {
      type: Object,
      default: {},
    },
    index: {
      type: Number,
    },
  },
  data: function() {
    return {
      value: null,
    }
  },
  computed: {
    account() {
      return app.user.account
    },
    showWater() {
      return this.index % 3 === 0 && ['姓名', '公司', '部门', '邮箱', '座机'].includes(this.head.label)
    },
    content: function() {
      const item = this.item
      const head = this.head
      if (head.content) {
        return head.content
      }
      const field = head.field || head.label
      let content = item[field]
      if (head.default && !content) {
        return head.default
      }
      if (head.type == 'tag' && typeof content === 'string') {
        content = [content]
      }
      return content
    },
    tdStyle: function() {
      const tdStyle = {}
      if (this.head.type && this.head.type != 'text') {
        tdStyle.textAlign = 'center'
      }
      if (this.head.colors) {
        tdStyle.backgroundColor = this.head.colors[this.value]
      }
      const field = this.head.field || this.head.label
      if(field==='归属人'&&this.item.color){
        tdStyle.backgroundColor = this.item.color
      }
      if (field == '公司' && this.item['公司排名'] == '9999991') {
        tdStyle.backgroundColor = '#f99'
      }
      if (field == '离职意愿度' && this.value && this.value != '--') {
        if (this.value > 80) {
          tdStyle.backgroundColor = '#f99'
        } else if (this.value > 60) {
          tdStyle.backgroundColor = '#ffc'
        } else {
          tdStyle.backgroundColor = '#ccf'
        }
      }
      return tdStyle
    },
    displayContent: function() {
      if (this.head.handleContent) {
        return this.head.handleContent(this.value)
      } else if (this.item.highlights && this.item.highlights[this.head.field || this.head.label]) {
        const field = this.head.field || this.head.label
        if (this.head.type == 'tag' && typeof this.item[field] === 'string') {
          return [this.item.highlights[field]]
        }
        return this.item.highlights[field]
      } else {
        return this.content
      }
    },
    tdTitle: function() {
      if (this.head.type === 'tooltip') {
        return ''
      }
      if (this.head.type == 'tag') {
        let tmp = ''
        if (this.content && this.content.tag === '已推荐') {
          tmp = `推荐人：${this.item['顾问']} 时间：${dateFormat(this.item.updatedAt, 'yyyy-mm-dd')}`
        } else {
          for (const i in this.content) {
            tmp = `${tmp + this.content[i]};`
          }
        }
        return tmp
      }
      if (this.head.label === '相关度') {
        return '点击查看解释'
      }
      if (this.head.type === 'select' && !Array.isArray(this.head.options)) {
        return this.head.options[this.content] || ''
      }
      return this.content
    },
    hasCcIcon: function() {
      if (this.head.label == '姓名' && !this.item['手机']) {
        return true
      }
      return false
    },
    hasO: function() {
      if (this.head.label == '姓名' && this.item.progress && this.item.progress.type === 'offer') {
        return true
      }
      return false
    },
    hasP: function() {
      if (this.head.label == '姓名' && this.item.progress && this.item.progress.type === '到岗') {
        return true
      }
      return false
    },
    hasSimi: function() {
      if (this.head.label == '姓名' && this.head.onClickSimi) {
        return true
      }
      return false
    },
    isXueku: function() {
      if (this.head.label == '公司' && this.item.isXueku) {
        return true
      }
      return false
    },
    simiClass: function() {
      if (this.head.label == '姓名') {
        if (this.item.status == 1) {
          return 'el-icon-question icon-lightred'
        } else if (this.item.status == 2) {
          return 'el-icon-success icon-blue'
        } else if (this.item.status == 3) {
          return 'el-icon-warning icon-red'
        } else if (this.item.status == 4) {
          return 'el-icon-error icon-grey'
        } else {
          return ''
        }
      }
    },
  },
  watch: {
    content: function() {
      this.value = this.content
    },
  },
  created: function() {
    this.value = this.content
  },
  methods: {
    onClick: function() {
      if (this.head.onClick) {
        this.head.onClick(this.item)
      }
    },
    onMouseover: function() {
      if (this.head.onMouseover) {
        this.head.onMouseover(this.item)
      }
    },
    onChange: function() {
      if (this.head.onChange) {
        this.head.onChange({ item: this.item, head: this.head, value: this.value })
      }
    },
    onClickSimi: function() {
      if (this.head.onClickSimi) {
        this.head.onClickSimi(this.item)
      }
    },
  },
}
</script>
